module.exports = __webpack_public_path__ + "static/media/Young_Ukulele.cb058f08.jpg";